export default "__VITE_ASSET__DqoFpeFO__"